/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: cjy
 * @Date: 2023-07-22 15:52:44
 * @LastEditors: cjy
 * @LastEditTime: 2023-09-05 17:57:14
 */
import '@/assets/js/doudouNewWebkitDsbridge';
// 防止页面出现报错信息，先在window挂上相关方法
window.openNotificationBack = () => {};
window.openCalendarAuthorizedCallBack = () => {};
window.commonCallBack = () => {};

const jsBridge = {
  platform: window.Android || window, // 平台变量（用于调用原生程序定义的方法）
  APPChannelName: 'ddq_app',
  bridge(params, isSys, type) {
    params[1] = params[1] || '';
    if (!(window.Android && type === 'window') && typeof params[1] !== 'string') {
      params[1] = JSON.stringify(params[1]);
    }
    if (window.Android && type === 'window') {
      return this.platform[params[0]](...params[1]);
    } else if (window.Android && type === 'ocModel') {
      return this.platform && this.platform.appHander && this.platform.appHander(params);
    } else { // ios
      return window.dsBridge.call(isSys ? 'methonNameSys' : 'methonNameAnSys', params);
    }
  },
  newBridge(params, isSys) {
    if (this.platform === window.Android) {
      return this.platform[params[0]] && this.platform[params[0]](params[1], params[2] || '', params[3] || '');
    } else {
      return window.dsBridge.call(isSys ? 'methonNameSys' : 'methonNameAnSys', params);
    }
  },
  // 打开webview不会关闭之前的
  entranceJumpPage(url) {
    this.bridge(['entranceJumpPage', [url], '', ''], false, 'window');
  },
  // 获取appToken
  getAppToken(callBack, params) { // callBack 为路由钩子中的next
    this.bridge(['getToken', params, 'getTokenSuccess', ''], false, 'ocModel');
    let resolveObj = '';
    const promise = new Promise((resolved) => {
      resolveObj = resolved;
    });
    window.getTokenSuccess = (token) => {
      resolveObj(token);
      callBack && callBack();
    };
    return promise;
  },
  getRegisterId(callBack, param = { isEncryption: 0 }) {
    window.getRegisterIdCallBack = callBack;
    return this.newBridge(['getRegisterId', JSON.stringify(param), 'getRegisterIdCallBack', '']);
  },
  newSetRightBtn(callBack, param = { }) {
    window.newSetRightBtnCallBack = callBack;
    return this.newBridge(['newSetRightBtn', JSON.stringify(param), 'newSetRightBtnCallBack', '']);
  },
  showNavSuperposedView(callBack, param = []) {
    window.showNavSuperposedViewCallBack = callBack;
    return this.newBridge(['showNavSuperposedView', JSON.stringify(param), 'showNavSuperposedViewCallBack', '']);
  },
  setWebpageSettingInfo(params = {}) {
    const {
      isIntercept = false, isUpload = false,
    } = params;

    window.setWebpageSettingInfoCallBack = (() => { });
    this.newBridge(['setWebpageSettingInfo', JSON.stringify({
      // pageName, 无需设置页面名称，如果是被iframe嵌入沿用被嵌入页面名称，如果是新大概页面，pageName等于modelName(可以通过modelName来区分页面)
      modelName: params.title,
      isIntercept,
      isUpload,
      interceptDesc: '合同涉及敏感信息，为了您的信息安全，请联系客服获取',
    }), 'setWebpageSettingInfoCallBack', '']);
  },
  // 通知app是否需要显示app头部左边按钮
  isShowNaviRight(flag) {
    this.bridge(['isShowNaviRight', JSON.stringify({ isShow: flag }), '', ''], false, 'ocModel');
  },
};
export default jsBridge;
